import { ServiceCookies } from '@services/ServiceCookies';
import { Region } from '@enums/RegionList';
import { getPriceForRegion, getPriceForStore } from '@entities/infoMessages/ui/YellowSlots/getTextMessage';
import config from '@app/config';

export const InstallingYellowSlots = (price: number, regionId: Region, storeId: number): void => {
  const regionPrice = getPriceForRegion(regionId);
  const storePrice = getPriceForStore(storeId);

  const validPrice = price >= regionPrice || (storePrice && price >= storePrice);

  if (validPrice && !ServiceCookies.getYellowSlot() && config.isCookiesYellowSlots) {
    ServiceCookies.setYellowSlot();
  }
};
